module.exports = __webpack_public_path__ + "img/album21_24.fa1d0944.jpg";